import { fromEvent, Observable } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

/**
 * Observable Drag. Return relative position without the first
 * container, or body, with position non static.
 */
export function mouseoverRelativeCoordinatesObservable(
  mouseenterEvent: MouseEvent,
  doc: Document = document,
): Observable<number> {
  mouseenterEvent.preventDefault();
  let container = mouseenterEvent.target as HTMLElement;
  while (
    container.tagName !== 'BODY' &&
    getComputedStyle(container).getPropertyValue('position') !== 'static'
  ) {
    container = container.parentElement as HTMLElement;
  }

  const { left, width } = container.getBoundingClientRect();
  const mouseleave = fromEvent<MouseEvent>(container, 'mouseleave');
  const mousemove = fromEvent<MouseEvent>(doc, 'mousemove');

  return mousemove.pipe(
    map(mousemoveEvent => {
      mousemoveEvent.preventDefault();
      return Math.min(1, Math.max(0, (mousemoveEvent.clientX - left) / width));
    }),
    takeUntil(mouseleave),
    startWith(
      Math.min(1, Math.max(0, (mouseenterEvent.clientX - left) / width)),
    ),
  );
}
